/**
 * Normalizes a filename to be ASCII-compatible for use in HTTP headers and S3 keys.
 * - Converts fancy quotes to their ASCII equivalents
 * - Replaces other non-ASCII characters with underscores
 * - Preserves ASCII characters, spaces, hyphens, underscores, and dots
 */
export function normalizeFilename(filename: string): string {
  return filename
    .normalize("NFD") // Decompose characters (e.g., é -> e + ´)
    .replace(/[\u0300-\u036f]/g, "") // Remove combining diacritical marks
    .replace(/[\u2018\u2019]/g, "'") // Left/Right single quotation mark -> apostrophe
    .replace(/[\u201C\u201D]/g, '"') // Left/Right double quotation mark -> quote
    .replace(/[\u2013\u2014]/g, "-") // En dash/Em dash -> hyphen
    .replace(/[/\\]/g, "-") // Replace forward/backward slashes with hyphens (prevent path traversal)
    .replace(/~/g, "") // Remove tilde (path-specific character)
    .replace(/[^\x20-\x7E._-]/g, "_") // Replace any remaining non-ASCII with underscore
    .replace(/\s+/g, "-") // Replace spaces with hyphens (for consistency)
    .replace(/_{2,}/g, "_") // Replace multiple underscores with single underscore
    .replace(/-{2,}/g, "-") // Replace multiple hyphens with single hyphen (consistent with spaces/underscores)
    .replace(/^_+|_+(?=\.)|_+$/g, "") // Remove leading/trailing underscores and underscores before dots
    .replace(/^-+|-+(?=\.)|-+$/g, "") // Remove leading/trailing hyphens and hyphens before dots
    .trim();
}

export const getFileKey = (location: string, id: string, fileName: string) => {
  return `${location}/${id}/${fileName}`;
};

export const getPublicFileUrl = (key: string) => {
  const url = process.env.USER_PUBLIC_ASSETS_DISTRIBUTION_URL;
  if (!url.startsWith("https://")) {
    return `https://${url}/${key}`;
  }
  return `${url}/${key}`;
};
